module.exports = __webpack_public_path__ + "static/media/clock.acb4858f.png";